import { render, staticRenderFns } from "./PreloaderSection.vue?vue&type=template&id=648673d9&scoped=true&"
import script from "./PreloaderSection.vue?vue&type=script&lang=js&"
export * from "./PreloaderSection.vue?vue&type=script&lang=js&"
import style0 from "./PreloaderSection.vue?vue&type=style&index=0&id=648673d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648673d9",
  null
  
)

export default component.exports